import {API} from 'aws-amplify';
import moment from "moment";
import * as AWS from "aws-sdk";
import LogRocket from 'logrocket';

function getMyInitiDocumentDb() {
    let myInitDb = {
        body: {
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_sku_silver_ok",
            "command": "aggregate",
            "database": process.env.REACT_APP_DATABASE,
            "query": [{"$limit": 2000}, {
                "$group": {
                    "_id": "$sku",
                    "categoria_principal_sku": {"$first": "$categoria_principal_sku"},
                    "id": {"$first": "$_id"},
                    "sku": {"$first": "$sku"},
                    "category_sku": {"$first": "$category_sku"},
                    "abcd": {"$first": "$abcd"},
                    "marca": {"$first": "$marca"},
                    "plc_local": {"$first": "$plc_local"},
                    "sub_categoria_sku": {"$first": "$sub_categoria_sku"},
                    "hero": {"$first": "$hero"}
                }
            }]
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentDbWithFilterPlanejamento(skip) {
    // console.log(JSON.parse(localStorage.getItem('formFilter')));
    let filters = JSON.parse(localStorage.getItem('formFilter'));
    let query = [];
    let queryC = "{";
    //let queryC = "";
    skip = skip * 20;


    if (filters.abcd.length > 0) {
        query.push({"abcd": {"$in": filters.abcd}});
        queryC = queryC.concat("\"abcd\": {\"$in\": " + JSON.stringify(filters.abcd) + "},");
    }
    if (filters.brand.length > 0) {
        query.push({"marca": {"$in": filters.brand}});
        queryC = queryC.concat("\"marca\": {\"$in\": " + JSON.stringify(filters.brand) + "},");
    }
    if (filters.category.length > 0) {
        query.push({"category_sku": {"$in": filters.category}});
        queryC = queryC.concat("\"category_sku\": {\"$in\": " + JSON.stringify(filters.category) + "},");
    }
    if (filters.chanel.length > 0) {
        query.push({"channel": {"$in": filters.chanel}});
        queryC = queryC.concat("\"channel\": {\"$in\": " + JSON.stringify(filters.chanel) + "},");
    }
    if (filters.hero.length > 0) {
        query.push({"hero": {"$in": filters.hero}});
        queryC = queryC.concat("\"hero\": {\"$in\": " + JSON.stringify(filters.hero) + "},");
    }
    if (filters.majorCategory.length > 0) {
        query.push({"categoria_principal_sku": {"$in": filters.majorCategory}});
        queryC = queryC.concat("\"categoria_principal_sku\": {\"$in\": " + JSON.stringify(filters.majorCategory) + "},");
    }
    if (filters.plcLocal.length > 0) {
        query.push({"plc_localsku": {"$in": filters.plcLocal}});
        queryC = queryC.concat("\"plc_localsku\": {\"$in\": " + JSON.stringify(filters.plcLocal) + "},");
    }
    if (filters.sku.length > 0) {
        query.push({"sku": {"$in": filters.sku}});
        queryC = queryC.concat("\"sku\": {\"$in\": " + JSON.stringify(filters.sku) + "},");
    }
    if (filters.subCategory.length > 0) {
        query.push({"sub_categoria_sku": {"$in": filters.subCategory}});
        queryC = queryC.concat("\"sub_categoria_sku\": {\"$in\": " + JSON.stringify(filters.subCategory) + "},");
    }

    /*
        if(filters.dataEnd !== ""){
            query.push({"data": {"$gte": {"$date": 1604188800000}, "$lte": {"$date": 1609459200000}}});
            queryC = queryC.concat(" \"data\": {\"$gte\": {\"$date\": 1604188800000}, \"$lte\": {\"$date\": 1609459200000}}");
        }
    */
    queryC = queryC.slice(0, -1);
    queryC = queryC.concat("}");
    query = JSON.stringify(query);
    // console.log(queryC);


    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_planejamento_quantidade_gold",
            "command": "find",
            "skip": skip,
            "limit": 20,
            "query": JSON.parse(queryC),
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    //console.log(myInitDb);
    return myInitDb;
}

function getMyInitiDocumentDbWithFilterPlanejamentoCount() {
    // console.log(JSON.parse(localStorage.getItem('formFilter')));
    let filters = JSON.parse(localStorage.getItem('formFilter'));
    let query = [];
    let queryC = "{";
    //let queryC = "";
    if (filters.abcd.length > 0) {
        query.push({"abcd": {"$in": filters.abcd}});
        queryC = queryC.concat("\"abcd\": {\"$in\": " + JSON.stringify(filters.abcd) + "},");
    }
    if (filters.brand.length > 0) {
        query.push({"marca": {"$in": filters.brand}});
        queryC = queryC.concat("\"marca\": {\"$in\": " + JSON.stringify(filters.brand) + "},");
    }
    if (filters.category.length > 0) {
        query.push({"category_sku": {"$in": filters.category}});
        queryC = queryC.concat("\"category_sku\": {\"$in\": " + JSON.stringify(filters.category) + "},");
    }
    if (filters.chanel.length > 0) {
        query.push({"channel": {"$in": filters.chanel}});
        queryC = queryC.concat("\"channel\": {\"$in\": " + JSON.stringify(filters.chanel) + "},");
    }
    if (filters.hero.length > 0) {
        query.push({"hero": {"$in": filters.hero}});
        queryC = queryC.concat("\"hero\": {\"$in\": " + JSON.stringify(filters.hero) + "},");
    }
    if (filters.majorCategory.length > 0) {
        query.push({"categoria_principal_sku": {"$in": filters.majorCategory}});
        queryC = queryC.concat("\"categoria_principal_sku\": {\"$in\": " + JSON.stringify(filters.majorCategory) + "},");
    }
    if (filters.plcLocal.length > 0) {
        query.push({"plc_localsku": {"$in": filters.plcLocal}});
        queryC = queryC.concat("\"plc_localsku\": {\"$in\": " + JSON.stringify(filters.plcLocal) + "},");
    }
    if (filters.sku.length > 0) {
        query.push({"sku": {"$in": filters.sku}});
        queryC = queryC.concat("\"sku\": {\"$in\": " + JSON.stringify(filters.sku) + "},");
    }
    if (filters.subCategory.length > 0) {
        query.push({"sub_categoria_sku": {"$in": filters.subCategory}});
        queryC = queryC.concat("\"sub_categoria_sku\": {\"$in\": " + JSON.stringify(filters.subCategory) + "},");
    }

    /*
        if(filters.dataEnd !== ""){
            query.push({"data": {"$gte": {"$date": 1604188800000}, "$lte": {"$date": 1609459200000}}});
            queryC = queryC.concat(" \"data\": {\"$gte\": {\"$date\": 1604188800000}, \"$lte\": {\"$date\": 1609459200000}}");
        }
    */
    queryC = queryC.slice(0, -1);
    queryC = queryC.concat("}");
    query = JSON.stringify(query);
    // console.log(queryC);


    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_planejamento_quantidade_gold",
            "command": "count_documents",
            "query": JSON.parse(queryC),
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function setPlanejamentoQuantidade(valor) {
    var d = new Date();
    var dateIso = d.toISOString();

    let filters = JSON.parse(localStorage.getItem('formFilter'));
    let query = [];
    let queryC = "{";
    //let queryC = "";
    if (filters.abcd.length > 0) {
        query.push({"abcd": {"$in": filters.abcd}});
        queryC = queryC.concat("\"abcd\": {\"$in\": " + JSON.stringify(filters.abcd) + "},");
    }
    if (filters.brand.length > 0) {
        query.push({"marca": {"$in": filters.brand}});
        queryC = queryC.concat("\"marca\": {\"$in\": " + JSON.stringify(filters.brand) + "},");
    }
    if (filters.category.length > 0) {
        query.push({"category_sku": {"$in": filters.category}});
        queryC = queryC.concat("\"category_sku\": {\"$in\": " + JSON.stringify(filters.category) + "},");
    }
    if (filters.chanel.length > 0) {
        query.push({"channel": {"$in": filters.chanel}});
        queryC = queryC.concat("\"channel\": {\"$in\": " + JSON.stringify(filters.chanel) + "},");
    }
    if (filters.hero.length > 0) {
        query.push({"hero": {"$in": filters.hero}});
        queryC = queryC.concat("\"hero\": {\"$in\": " + JSON.stringify(filters.hero) + "},");
    }
    if (filters.majorCategory.length > 0) {
        query.push({"categoria_principal_sku": {"$in": filters.majorCategory}});
        queryC = queryC.concat("\"categoria_principal_sku\": {\"$in\": " + JSON.stringify(filters.majorCategory) + "},");
    }
    if (filters.plcLocal.length > 0) {
        query.push({"plc_localsku": {"$in": filters.plcLocal}});
        queryC = queryC.concat("\"plc_localsku\": {\"$in\": " + JSON.stringify(filters.plcLocal) + "},");
    }
    if (filters.sku.length > 0) {
        query.push({"sku": {"$in": filters.sku}});
        queryC = queryC.concat("\"sku\": {\"$in\": " + JSON.stringify(filters.sku) + "},");
    }
    if (filters.subCategory.length > 0) {
        query.push({"sub_categoria_sku": {"$in": filters.subCategory}});
        queryC = queryC.concat("\"sub_categoria_sku\": {\"$in\": " + JSON.stringify(filters.subCategory) + "},");
    }

    /*
        if(filters.dataEnd !== ""){
            query.push({"data": {"$gte": {"$date": 1604188800000}, "$lte": {"$date": 1609459200000}}});
            queryC = queryC.concat(" \"data\": {\"$gte\": {\"$date\": 1604188800000}, \"$lte\": {\"$date\": 1609459200000}}");
        }
    */
    queryC = queryC.slice(0, -1);
    queryC = queryC.concat("}");


    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_planejamento_quantidade_gold",
            "command": "update_many",
            "query": JSON.parse(queryC),
            "update": {
                "$mul": {"valor": valor},
                "$currentDate": {"creationDate": true}
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function setUpdatePlanejamentoQuantidadeUnitario(key, value) {

    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_planejamento_quantidade_gold",
            "command": "update_many",
            "query": {"_id": {"$oid": key}},
            "update": {
                "$set": {"valor": parseInt(value, 10)},
                "$currentDate": {"creationDate": true}
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

async function callIndividual(valores) {
    //console.log('--->',valores);
    for (var k in valores) {
        if (valores.hasOwnProperty(k)) {
            // alert("Key is " + k + ", value is " + valores[k]);
            await API.post('dr', '/mongoDB', setUpdatePlanejamentoQuantidadeUnitario(k, valores[k]))
        }
    }
    return true;
}

function getMyInitiAgrupamento(filtros) {
    let myInitDb = {
        body: {
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_forecast_gold",
            "command": "aggregate",
            "database": process.env.REACT_APP_DATABASE,
            "query": [
                {
                    $match: {
                        $and: [
                            {
                                $or: [
                                    {"rf": "actual"},
                                    {"rf": filtros.rf}
                                ]
                            },
                            {
                                "cost_center_concat": filtros.cost_center_concat
                            },
                            {
                                "data_ref": {
                                    "$gte": {"$date": (filtros.mes_inicio)},
                                    "$lte": {"$date": (filtros.mes_fim)}
                                }
                            }
                        ]
                    }
                },
                {$sort: {"level_descr": 1, "group_level_2": 1, "cost_center_concat": 1, "data_ref": 1}}
            ]
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDistinct(query) {
    let myInitDb = {
        body: {
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_filtro",
            "command": "distinct",
            "database": process.env.REACT_APP_DATABASE,
            "query": query,
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

async function callSetIndividualForecast(valores_antigo, valores, data_corrente) {
    var campos = valores.filter(colunas => colunas.type == 'row' && colunas.editado == true);
    valores_antigo = valores_antigo.filter(colunas => colunas.type == 'row');
    data_corrente = new Date(data_corrente);

    for await (let campos_dentro of campos) {
        for await(const [key, value] of Object.entries(campos_dentro)) {
            if (!isNaN(Date.parse(key))) {
                var campo_n_editado = valores_antigo.filter(colunasx => colunasx.acc_description_edit === campos_dentro.acc_description_edit && colunasx.cost_center === campos_dentro.cost_center && colunasx.level_descr === campos_dentro.level_descr);
                //console.log(campos_dentro, " ", campo_n_editado[0])
                if ((new Date(key)) >= data_corrente) {
                    if (campos_dentro[key] !== campo_n_editado[0][key]) {
                        var json = {
                            body: {
                                "database": process.env.REACT_APP_DATABASE,
                                "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_forecast_gold",
                                "command": "update_many",
                                "query": {
                                    data_ref: {
                                        "$gte": {"$date": moment(key).format("YYYY-MM-DD") + "T00:00:00.000Z"},
                                        "$lte": {"$date": moment(key).format("YYYY-MM-DD") + "T00:00:00.000Z"}
                                    },
                                    "account_concat": campos_dentro.acc_description_edit,
                                    "cost_center": campos_dentro.cost_center,
                                    "level_descr": campos_dentro.level_descr,
                                    "rf": campos_dentro.rf
                                },
                                "update": {
                                    "$set": {"forecast": parseFloat(campos_dentro[key])}
                                }
                            },
                            headers: {
                                'Access-Control-Allow-Headers': 'Content-Type',
                                'Access-Control-Allow-Origin': 'http://localhost:3000',
                                'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                                drtoken: localStorage.getItem('token')
                            }
                        };
                        await setUpdateForecast(json)
                    }
                }
            }
        }
    }
    return true;
}


async function setUpdateForecast(json) {
    await API.post('dr', '/mongoDB', json).then(response => {
        //new Promise(r => setTimeout(r, 5000));
        return response;
    }).catch(erro => {
        LogRocket.captureException(erro);
    })

    /*return new Promise((resolve, reject) => {
        window.setTimeout(() => {
            resolve(API.post('dr', '/mongoDB', json))
        }, 1);
    });*/
}


export default {

    getAllSkus: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb()).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    getRowsForecast: (filtros) =>
        API.post('dr', '/mongoDB', getMyInitiAgrupamento(filtros)).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),
    getCostCenter: () =>
        API.post('dr', '/mongoDB', getMyInitiDistinct('cost_center_concat')).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    getPeriod: () =>
        API.post('dr', '/mongoDB', getMyInitiDistinct('rf')).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    setForecast: (valores_antigo, valores, data_corrente) => {
        //let retorno = callSetIndividualForecast(valores_antigo, valores);

        //return Promise.all(callSetIndividualForecast(valores_antigo, valores, data_corrente))


        const promise = new Promise((resolve, reject) => {
            try {
                resolve(callSetIndividualForecast(valores_antigo, valores, data_corrente))
            } catch (e) {
                reject(e)
            }
        })

        return promise.then(resposta => {
            return resposta;
        }, erro => {
            LogRocket.captureException(erro)
        })

        /*return new Promise((resolve, reject) => {
            window.setTimeout(() => {
                resolve();
            }, 2000);
        });*/

    },

    getFilterPlanejamentoQuantidade: ({skip}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbWithFilterPlanejamento(skip)).then(response => {
            return response.response;
        }),

    getFilterPlanejamentoQuantidadeContador: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbWithFilterPlanejamentoCount()).then(response => {
            return response.response;
        }),


    setPlanejamentoQuantidadeLote: ({valor}) =>
        API.post('dr', '/mongoDB', setPlanejamentoQuantidade(valor)).then(response => {
            return response.response;
        }),

    setPlanejamentoQuantidadUnitario: (valores) => {
        /* API.post('dr', '/mongoDB', setPlanejamentoQuantidadeUnitario(valores)).then(response => {
             return response.response;
         })*/

        let retorno = callIndividual(valores.valor);
        return new Promise((resolve, reject) => {
            window.setTimeout(() => {
                resolve();
            }, 2000);
        });

    },
};
